import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from './common.js';
import { QualityProviderMessageSchema } from './QualityProcessing.js';
export const ClaimTranscriptCaptureRequestSchema = z
    .object({
    sessionId: UuidSchema.optional(),
    limit: z.number().int().min(1).max(100).default(20),
    leaseDurationMs: z.number().int().min(30_000).max(900_000).default(120_000),
})
    .strict();
export const TranscriptCaptureClaimSchema = z.object({
    sessionId: UuidSchema,
    callId: z.string().min(1),
    conversationProvider: z.string().nullable(),
    claimToken: UuidSchema,
    attemptCount: z.number().int().positive(),
});
export const TranscriptCaptureClaimsSchema = z.object({
    items: z.array(TranscriptCaptureClaimSchema),
});
export const ProviderTranscriptSnapshotSchema = z
    .object({
    id: z.string().min(1),
    transcript: z.string().optional(),
    messages: z.array(QualityProviderMessageSchema),
    durationSeconds: z.number().int().nonnegative(),
})
    .strict();
export const TranscriptCaptureTransitionSchema = z.discriminatedUnion('action', [
    z
        .object({
        action: z.literal('complete'),
        claimToken: UuidSchema,
        snapshot: ProviderTranscriptSnapshotSchema,
    })
        .strict(),
    z
        .object({
        action: z.literal('retry'),
        claimToken: UuidSchema,
        reason: z.string().min(1).max(100),
        nextAttemptAt: IsoDateTimeSchema,
    })
        .strict(),
    z
        .object({
        action: z.literal('fail'),
        claimToken: UuidSchema,
        reason: z.string().min(1).max(100),
    })
        .strict(),
]);
export const TranscriptCaptureResultSchema = z.object({
    sessionId: UuidSchema,
    status: z.enum(['pending', 'completed', 'failed']),
});
export const InterviewTranscriptCapturedEventSchema = z.object({
    subject: z.literal('interviews-data.session.transcript-captured'),
    correlationId: z.string(),
    occurredAt: IsoDateTimeSchema,
    data: z.object({ sessionId: UuidSchema, projectId: UuidSchema, organizationId: UuidSchema }),
});
//# sourceMappingURL=TranscriptCapture.js.map